<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'">
            <table-tool-bar>
                <Button
                    type="primary"
                    v-if="$can('doAuth')"
                    @click="showAuth = true"
                    :disabled="loading"
                    :class="preCls + 'button-margin'"
                >授权</Button>
            </table-tool-bar>
            <Row>
                <Col span="24">
                    <Table
                        ref="mt"
                        :columns="columns"
                        :data="list"
                        :loading="loading"
                        :height="mtHeight"
                    ></Table>
                </Col>
            </Row>
            <smart-modal
                title="数据授权设置"
                :height="600"
                :width="1000"
                v-model="showAuth"
                :maskClosable="maskClosable"
                @close-by-confirm="fetch"
            >
                <auth-emp-setup v-if="showAuth" :list="list"></auth-emp-setup>
            </smart-modal>
        </div>
    </div>
</template>
<script>
import { accessList } from '@/api/sys-res'
import AuthEmpSetup from './auth-emp-setup'
const WINDOW_HEIGHT = document.body.clientHeight
const fetchData = function() {
    return Promise.all([Dict.get(["auth_module"]), accessList()])
}
import Dict from "_u/dict"
import { mapCell } from "@/components/grid/renderCell"
export default {
    name: 'dataAuth',
    components: {
        AuthEmpSetup
    },
    data() {
        return {
            loading: true,
            maskClosable: false,
            mtHeight: 360,
            showAuth: false,
            list: [],
            dict: {
                authModule: Dict.NULL
            }
        }
    },
    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    width: 60,
                    title: '序号',
                    align: 'center'
                },
                {
                    title: '模块名称',
                    align: 'left',
                    key: 'module',
                    render: mapCell(this.dict.authModule.val())
                },
                {
                    title: '被授权人',
                    align: 'left',
                    key: 'realname'
                }
            ]
        }
    },
    methods: {
        fetch() {
            this.loading = true
            accessList()
                .then(res => {
                    this.setAuthList(res.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        fillData(args) {
            var [dictGroup, auth] = args
            Object.keys(this.dict).forEach(name => {
                this.dict[name] = dictGroup[name]
            })
            this.setAuthList(auth.data)
            this.loading = false
        },
        setAuthList(data) {
            let resList = data.list || []
            this.list = resList
        }
    },
    mounted() {
        var me = this
        this.$nextTick(() => {
            var mt = this.$refs.mt
            me.mtHeight =
                WINDOW_HEIGHT - mt.$el.getBoundingClientRect().top - 40
        })
    },
    beforeRouteEnter(to, from, next) {
        fetchData().then(args => {
            next(vm => vm.fillData(args))
        })
    }
}
</script>
